<script>
    import {router} from "../lib/Router/Router.svelte";
    import R, {LOADER} from "../lib/requests";
    import user from "../stores/user";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Warning from "../components/pages/Warning.svelte";
    import Alert from "../stores/alerts";

    let categories = null;
    let list = null;
    let total = 0;
    let sortId = '0';
    let search = {
        title: '',
        document_category_id: null,
        sort_field: null,
        sort_way: null,
        limit: 50,
        offset: 0
    }

    const load = () => {
        const onSuccess = result => {
            if (categories == null) {
                categories = result.categories;
            }
            list = result.list;
            total = result.total;

            list.map(item => {
                let arr = item.document_filename.split('.');
                let extension = arr[arr.length - 1].toLowerCase();
                item.icon = 'fa-file-text-o';
                if (extension == 'pdf') {
                    item.icon = 'fa-file-pdf-o';
                } else if (extension == 'doc' || extension == 'docx') {
                    item.icon = 'fa-file-word-o';
                } else if (extension == 'xls' || extension == 'xlsx') {
                    item.icon = 'fa-file-excel-o';
                }
            });
        }

        const onFailure = err => {
        };

        R.handle(R.document.index, search, onSuccess, onFailure, list == null ? LOADER.PAGE : LOADER.POPUP);
    }

    const download = (id) => {
        const onSuccess = result => {
            window.open(result.url, "_blank");
        }

        const onFailure = err => {
            if (err.code === 'file_not_found') {
                Alert.warning("Έγγραφα μελών", "Λυπούμαστε!\nΦαίνεται πως το αρχείο που ζητήσατε δεν υπάρχει ή έχει διαγραφεί.");
                return;
            }
            Alert.warning("Έγγραφα μελών", err.message);
        };

        if (!user.canAccessDocuments()) {
            Alert.warning("Έγγραφα μελών", `Υπάρχουν οφειλές συνδρομών πέραν της ${$user.document_subscription_years}ετίας.\n
                Παρακαλούμε πολύ φροντίστε για την εξόφλησή τους προκειμένου να έχετε πρόσβαση στα έγγραφα.`);
            return;
        }

        R.handle(R.document.download, {id}, onSuccess, onFailure, LOADER.POPUP);
    }

    const toggleCategory = category => {
        if (search.document_category_id == category.id) {
            search.document_category_id = null;
        } else {
            search.document_category_id = category.id;
        }
        load();
    }

    const onSearch = () => {
        if (sortId == 0) {
            search.sort_field = null;
            search.sort_way = null;
        } else if (sortId == 1) {
            search.sort_field = 'created_at';
            search.sort_way = 'DESC';
        } else if (sortId == 2) {
            search.sort_field = 'created_at';
            search.sort_way = 'ASC';
        }
        load();
    }

    if (!user.isActive()) {
        router.go('/account-error')()
    }

    $: {
        if ($user.token && !list) {
            load();
        }
    }
</script>

<div class="container">
    <div class="mb-5">
        <h1>Έγγραφα Μελών</h1>
        <div class="heading-separator"></div>
    </div>

    {#if $user.token}
        {#if !user.canAccessDocuments()}
            <h3 class="mb-3">{ $user.lastname } { $user.firstname }</h3>
            <p class="">
                Φαίνεται πως υπάρχουν οφειλές συνδρομών πέραν της { $user.document_subscription_years }ετίας.<br>
                Παρακαλούμε πολύ φροντίστε για την εξόφλησή τους προκειμένου να έχετε πρόσβαση στα έγγραφα.
            </p>
        {:else}
            <div class="row">
                <div class="col-xl-8 col-lg-6 col-md-7">
                    <div class="form-group">
                        <label>Αναζήτηση εγγράφου</label>
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" bind:value="{ search.title }" on:change={ onSearch }
                                   placeholder="τίτλος εγγράφου">
                            <button class="btn btn-outline-secondary" type="button" on:click={ onSearch }>
                                <AppIcon icon="search"/>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-5">
                    <div class="form-group">
                        <label>Ταξινόμηση</label>
                        <select class="form-select" bind:value="{ sortId }" on:change={ onSearch }>
                            <option value="0">Βάση τίτλου</option>
                            <option value="1">Πρώτα τα νεότερα έγγραφα</option>
                            <option value="2">Πρώτα τα παλαιότερα έγγραφα</option>
                        </select>
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-xl-4 col-lg-4">
                    <p class="small text-gray">Επιλέξτε κατηγορία</p>
                    {#if categories != null}
                        <div class="list-group mb-5">
                            {#each categories as category}
                                <button class="list-group-item document-category-item"
                                        class:active={ category.id == search.document_category_id }
                                        on:click={ () => toggleCategory(category) }>
                                    { category.name }
                                </button>
                            {/each}
                        </div>
                    {/if}
                </div>
                <div class="col-xl-8 col-lg-8">
                    {#if list != null}
                        <p class="small text-gray">
                            Πατήστε πάνω σε ένα έγγραφο για να το κατεβάσετε στον υπολογιστή σας.
                        </p>
                        <div class="list-group">
                            {#each list as item}
                                <button class="list-group-item document-item" on:click={ () => download(item.id) }>
                                    <span class="icon"><i class="fa { item.icon }"></i></span>
                                    <span class="document-item-content">
                                        <span class="title">{ item.title }</span>
                                        <span class="category">{ item.category_name }</span>
                                        {#if item.description}
                                            <span class="description">{ item.description }</span>
                                        {/if}
                                        <span class="created_at">{ item.created_at }</span>
                                    </span>
                                </button>
                            {/each}
                        </div>
                    {/if}
                </div>
            </div>
        {/if}
    {:else}
        <Warning warning="no-user"/>
    {/if}
</div>

<style>

    .document-category-item {
        font-family: var(--secondary-font);
        text-align: left;
    }

    .document-item {
        display: flex;
        text-align: left;
    }

    .document-item .icon {
        display: block;
        font-size: 16px;
        color: #6f6f6f;
        width: 25px;
    }

    .document-item .title {
        display: block;
        font-family: var(--secondary-font);
        font-weight: bold;
    }

    .document-item .category {
        display: block;
        font-size: 0.8rem;
        font-weight: 600;
        color: #555;
    }

    .document-item .description {
        display: block;
        font-size: 0.8rem;
        color: #555;
        margin-top: 5px;
    }

    .document-item .created_at {
        display: block;
        font-size: 0.8rem;
        color: #a3a3a3;
        margin-top: 5px;
    }

    /*a.list-group-item:focus, a.list-group-item:hover, button.list-group-item:focus, button.list-group-item:hover {*/
    /*    color: #555;*/
    /*    text-decoration: none;*/
    /*    background-color: #f5f5f5;*/
    /*}*/
</style>